import '../../../pages/Admin/Admin.scss';
import '../../../pages/Admin/Organizations/EditOrganization/EditOrganization.scss';

import { Input } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const OrganizationDetails = observer(() => {
  const os = useStores().organizationsEditorStore;

  return (
    <>
      <div className='admin-edit-section'>
        <h2>Organization name*</h2>
        <div className='inputs-container wide-input'>
          <Input
            label='Name'
            type='text'
            value={os.organization.name ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (os.organization.name = e.currentTarget.value)}
          />
        </div>
      </div>
      <div className='admin-edit-section'>
        <div className='inputs-container'>
          <div className='input-wrapper'>
            <Paragraph>
              <>Number of licenses to add*</>
            </Paragraph>
            <Input
              label='Number of licenses'
              value={os.numberOfLicensesToAdd ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                let licensesCount = e.currentTarget.value.replace(/[^0-9]/g, '');
                os.numberOfLicensesToAdd = licensesCount;
              }}
            />
          </div>
        </div>
        <Paragraph>
          <strong className='current-licenses-info'>Current number of licenses: {os.organization.numberOfInvites ?? ''}</strong>
        </Paragraph>
      </div>
      <div className='admin-edit-section'>
        <h2>Student duration (month)*</h2>
        <div className='inputs-container wide-input'>
          <Input
            label='Student duration'
            type='number'
            value={os.organization.membershipDurationMonth ?? 0}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (os.organization.membershipDurationMonth = Number(e.currentTarget.value))}
          />
        </div>
        <Paragraph>
          <span className='required-info'>*required field</span>
        </Paragraph>
      </div>
    </>
  );
});

export default OrganizationDetails;
